import { SizeChartUI } from "./SizeChartUI";
import { StandardProps } from "../componentMap";
import { cleanHtml } from "../../utils/string/cleanHtml";

export function SizeChart({ product }: Pick<StandardProps, "product">) {
  const sizeInfoExcludedCategory = product?.browsePageHierarchy?.find(
    (bph) =>
      bph.name?.toLowerCase().indexOf("jewellery") > -1 ||
      bph.name?.toLowerCase().indexOf("watches") > -1,
  );
  const sizeGuideContent =
    cleanHtml((product.sizeGuide || "").replace(/_x000D_/g, "")) || "";

  const showSizeChartInfo = !sizeInfoExcludedCategory && sizeGuideContent;

  return showSizeChartInfo ? (
    <SizeChartUI sizeGuideContent={sizeGuideContent} />
  ) : null;
}
